﻿import * as React from 'react';
import { Container, Row, Col, Button } from 'reactstrap';
import { RouteComponentProps } from 'react-router-dom';
import './About.css'

class About extends React.PureComponent<{}, { isOpen: boolean }> {
    public state = {
        isOpen: false
    };

    public render() {
        return (
            <div className="about">
                <div className="page-banner" style={{
                    backgroundImage: 'url("../img/about-ourmission.jpg")'
                }}>
                    <h1>Our Mission</h1>
                </div>
                <Container fluid>
                   
                    <Row className="locally-owned">
                        <Col className="content" md="6" sm="12">
                            <h2>"Locally" Owned and Operated</h2>
                            <p>Locally owned and operated, Premier Pressure Washing &amp; Window Cleaning offers cleaning services for both residential and commercial properties. Our commercial-grade equipment allows us to combine heat and pressure to remove the toughest of stains and grimes. Combined with the latest industry techniques, we offer a new level of cleanliness for your home, business, or property.</p>
                            <p>Our equipment also has a variable delivery system, which allows us to control the output of heat and pressure to clean even the most delicate of surfaces.</p>
                        </Col>
                        <Col className="image" md="6" sm="12" style={{
                            backgroundImage: 'url("../img/about-supportlocal.jpeg")'
                        }}>
                        </Col>
                    </Row>
                    <Row className="our-promise">
                        <Col className="image"  md="6" sm="12" style={{
                            backgroundImage: 'url("../img/about-ourpromise.jpg")'
                        }}>
                        </Col>
                        <Col className="content" md="6" sm="12" >
                            <h2>Our Promise</h2>
                            <p>Premier Pressure Washing &amp; Window Cleaning isn&apos;t your typical power washing company, we are trained experts. All of our staffs are properly trained before they are on the field. You can trust us to preserve and serve for your property and community."</p>
                            <p>We offer a 100% satisfaction guaranteed on every wash. If you aren&apos;t happy with the results neither are we.  We provide services to all of greater Phoenix areas, please call or email us for additional details. Get started with a free price quote by calling us at (602) 689-6045 or email us at <a href="mailto:info@premierpressurewash.com">info@premierpressurewash.com</a>.</p>
                        </Col>
                    </Row>
                </Container>
            </div>
        );
    }
};

export default About;


